import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-5',
    grid: 'grid grid-cols-1 gap-3 sm:gap-5 lg:grid-cols-2'
  }
});
